import React from "react";
import { Link } from "gatsby";
import "./Nav.css"; // 新建样式文件

const Nav = () => {
  return (
    <header className="site-header">
      <div className="nav-container">
        {/* Logo区域 */}
        <Link to="/" className="logo">
          <img src="/images/company-logo.png" alt="Your Company Logo" />
          {/* 若暂时无Logo，用文字替代：<span>YourBrand</span> */}
        </Link>

        {/* 导航菜单 */}
        <nav className="nav-menu">
          <Link to="/" activeClassName="active">Home</Link>
          <Link to="/about" activeClassName="active">About us</Link>
          <Link to="/news" activeClassName="active">News</Link>
          <Link to="/products" activeClassName="active">Products</Link>
          <a href="https://www.lazada.com/your-store" target="_blank" rel="noopener noreferrer">Lazada</a>
          <Link to="/contact" activeClassName="active">Contact us</Link>
        </nav>

        {/* 语言切换 */}
        <div className="language-switch">
          <select>
            <option value="en">English</option>
            <option value="es">Español</option>
            <option value="ar">العربية</option>
          </select>
        </div>
      </div>
    </header>
  );
};

export default Nav;